import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {EmailService} from '../../../services/email.service';
import {Email, ResidentEmailRecipient} from '../../../types/email-data.types';
import {FilterRecipients, FilterRecipientsItem} from '../../../services/filter-recipients';
import {ApiClientService} from '../../../services/api-client.service';
import { ReportBuilderApiService } from '../../../services/api/report-builder-api.service';
import { IReport } from '../../../types/api-response/report/report';
import { AlertService } from '../../../services/alert.service';

declare const toastr: any;

@Component({
    selector: 'choice-recipients-modal',
    templateUrl: './choice-recipients-modal.component.html',
    styleUrls: ['./choice-recipients-modal.component.scss']
})
export class ChoiceRecipientsComponent implements OnInit {
    @Output() save: EventEmitter<any> = new EventEmitter<any>();
    showModal = false;
    data: Email = new Email();
    filter: FilterRecipients;
    reports = [];
    showReportsSpinner = false;
    filterRecipients: FilterRecipients;

    constructor(
        public es: EmailService,
        private reportApi: ReportBuilderApiService,
        private alertService: AlertService
    ) {}

    ngOnInit(): void {
        this.filterRecipients = this.es.filterRecipients;
        if(!this.showEmailWaiverSettingsCheckbox())
            this.filterRecipients.ignoreWaiverSettings = -1;
        setTimeout(() => this.showModal = true, 300);
    }

    trackByRecipientFn(index, item: FilterRecipientsItem) {
        return item.buildingId;
    }

    trackByResidentFn(index, item: ResidentEmailRecipient) {
        return item.id;
    }

    hideModal(): void {
        this.es.isChoiceRecipientsModalShow = false;
        this.es.showSearchInstructionsModal = false;
    }

    saveRecipients() {
        this.save.emit(this.es.filterRecipients.getFilterState());
        this.hideModal();
    }

    orderBy(fieldName: string, event: any) {
        if (this.filterRecipients.filteredResidents.length < 2) return;

        const clickedElement = (event.target.className === 'footable-sort-indicator') ? event.target.parentElement : event.target;
        const parent = clickedElement.parentElement;
        let order = 'asc';

        if (!clickedElement.className) {
            Array.prototype.forEach.call(parent.children, (item) => {
                item.removeAttribute('class');
            });
        }
        if (clickedElement.classList.contains('footable-sorted')) {
            clickedElement.classList.remove('footable-sorted');
            clickedElement.classList.add('footable-sorted-desc');
            order = 'desc';
        } else {
            clickedElement.classList.remove('footable-sorted-desc');
            clickedElement.classList.add('footable-sorted');
            order = 'asc';
        }

        this.filterRecipients.orderBy = `${fieldName}|${order}`;
        this.filterRecipients.residents.sort((a: any, b: any) => {
            if (a[fieldName] < b[fieldName]) {
                return order == 'asc' ? -1 : 1;
            } else if (a[fieldName] > b[fieldName]) {
                return order == 'asc' ? 1 : -1;
            } else {
                return 0;
            }
        });
    }

    getReportsWithEmails() {
        this.showReportsSpinner = true;
        this.reportApi.getReportsList().subscribe(
            result => this.reports = result.entities,
            null,
            () => this.showReportsSpinner = false
        );
    }

    selectRecipientsByReport(report: IReport) {
        if(!report) {
            return;
        }

        this.reportApi.extractReportDetails(report.id).subscribe(
            details => {
                const toastSuccessMessage = 'All Recipients are selected according to report and filter conditions';

                if(details.emails.length) {
                    this.checkResidents(details.emails, 'email');
                    this.alertService.toast.success(toastSuccessMessage);
                } else if (details.units.length) {
                    this.checkResidents(details.units, 'suiteNumber');
                    this.alertService.toast.success(toastSuccessMessage);
                } else {
                    this.alertService.toast.warning('Selected report does not contain email addresses or unit numbers');
                }
            },
            null,
            () => this.showReportsSpinner = false
        );
    }

    /**
     * Check residents by property values
     *
     * @param values
     * @param propertyName
     */
    private checkResidents(values: any[], propertyName: keyof ResidentEmailRecipient) {
        this.filterRecipients.filteredResidents.forEach(resident => {
            if(values.includes(resident[propertyName])) {
                resident.checked = true;
            }
        });

        this.filterRecipients.updateCheckboxState();
    }

    onSelectByReportChange(event) {
        if(event.target.checked && this.reports.length === 0)
            this.getReportsWithEmails();
    }

    showEmailWaiverSettingsCheckbox() {
        return this.filterRecipients.filters.some(f => f.cNSettings && f.cNSettings.useEmailWaiver);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}




// WEBPACK FOOTER //
// /app/src/app/views/email/choice-recipients-modal/choice-recipients-modal.component.ts